import React from 'react';
import Heading from '@atlaskit/heading';
import { IconTile } from '@atlaskit/icon';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import CopyIcon from '@atlaskit/icon/core/copy';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { Flex, Text, Stack, xcss, Box } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { WizardInfoItem } from '../../../../../../../common/ui/wizard/info-item/index.tsx';
import { useUsersAndRolesStore } from '../../../../../../../services/store/users-and-roles/index.tsx';
import { messages } from './messages.tsx';

export const AdminContent = () => {
	const { formatMessage } = useIntl();

	const [{ usersWithoutCustomRole, usersWithoutAdminRole }] = useUsersAndRolesStore();

	if (usersWithoutCustomRole.data === null || usersWithoutAdminRole.data === null) {
		// Users should not see this screen if one of the requests is still loading or error
		throw new Error(
			'[Optimal StepFive Admin Content] should not be rendered if users are still loading',
		);
	}

	const usersWithoutCustomRoleCount = usersWithoutCustomRole.data.count;
	const usersWithoutAdminRoleCount = usersWithoutAdminRole.data.count;

	return (
		<Flex direction="column" rowGap="space.200">
			<Heading size="xlarge">{formatMessage(messages.titleNonFinal)}</Heading>
			<Text>{formatMessage(messages.descriptionNonFinal)}</Text>
			<Stack space="space.050">
				<Box xcss={listTitleWrapperStyles}>
					<Heading size="small" as="h2">
						{formatMessage(messages.listTitleNonFinal)}
					</Heading>
				</Box>
				<WizardInfoItem
					iconTile={<IconTile icon={CopyIcon} appearance="magenta" label="" />}
					description={formatMessage(messages.configureChatIntegrationsNonFinal)}
				/>
				{usersWithoutAdminRoleCount > 0 && (
					<WizardInfoItem
						iconTile={<IconTile icon={CheckCircleIcon} appearance="purple" label="" />}
						description={formatMessage(messages.giveProductAdminRoleNonFinal, {
							adminCount: usersWithoutAdminRoleCount,
						})}
					/>
				)}
				{usersWithoutCustomRoleCount > 0 && (
					<WizardInfoItem
						iconTile={<IconTile icon={PeopleGroupIcon} appearance="orange" label="" />}
						description={formatMessage(messages.giveProductRoleNonFinal, {
							userCount: usersWithoutCustomRoleCount,
						})}
					/>
				)}
			</Stack>
		</Flex>
	);
};

const listTitleWrapperStyles = xcss({ paddingTop: 'space.100', paddingBottom: 'space.100' });
